(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-style-1"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

(function () {

  'use strict';


  /* =========================================================
     PRODUCT CAROUSEL
     ========================================================= */

  class MFProductCarousel {

    constructor(root) {

      this.root = root;

      this.track =
        root.querySelector(
          '.mf-carousel-track'
        );

      this.slides =
        Array.from(
          root.querySelectorAll(
            '.mf-product-slide'
          )
        );

      this.prev =
        root.querySelector(
          '.mf-carousel-prev'
        );

      this.next =
        root.querySelector(
          '.mf-carousel-next'
        );

      this.dots =
        root.querySelector(
          '.mf-carousel-dots'
        );

      this.current = 0;

      this.visible = 3;

      this.total = 0;


      if (
        !this.track ||
        !this.slides.length
      ) {

        return;

      }


      this.setup();

    }


    /* =======================================================
       SETUP
       ======================================================= */

    setup() {

      this.updateVisible();

      this.bindEvents();

      this.update();

    }


    /* =======================================================
       VISIBLE SLIDES
       ======================================================= */

    getVisible() {

      if (
        window.innerWidth <= 749
      ) {

        return 1;

      }


      if (
        window.innerWidth <= 1100
      ) {

        return 2;

      }


      return 3;

    }


    /* =======================================================
       UPDATE VISIBLE
       ======================================================= */

    updateVisible() {

      this.visible =
        this.getVisible();


      this.total =
        Math.max(
          1,
          this.slides.length -
          this.visible +
          1
        );


      if (
        this.current >=
        this.total
      ) {

        this.current =
          this.total - 1;

      }


      this.updateSlideWidths();

      this.createDots();

      this.update();

    }


    /* =======================================================
       SLIDE WIDTHS
       ======================================================= */

    updateSlideWidths() {

      if (
        this.visible === 1
      ) {

        this.slides.forEach(
          function (slide) {

            slide.style.flexBasis =
              '100%';

            slide.style.marginRight =
              '0';

          }
        );

        return;

      }


      var gap = 20;


      var width =
        'calc((' +
        '100% - ' +
        (
          (this.visible - 1) *
          gap
        ) +
        'px) / ' +
        this.visible +
        ')';


      this.slides.forEach(
        function (slide) {

          slide.style.flexBasis =
            width;

          slide.style.marginRight =
            gap + 'px';

        }
      );

    }


    /* =======================================================
       CREATE DOTS
       ======================================================= */

    createDots() {

      if (!this.dots) {

        return;

      }


      this.dots.innerHTML = '';


      var pages =
        Math.max(
          1,
          this.slides.length -
          this.visible +
          1
        );


      for (
        var i = 0;
        i < pages;
        i++
      ) {

        var button =
          document.createElement(
            'button'
          );


        button.type =
          'button';


        button.className =
          'mf-carousel-dot' +
          (
            i === this.current
              ? ' is-active'
              : ''
          );


        button.setAttribute(
          'aria-label',
          'Go to product slide ' +
          (i + 1)
        );


        button.dataset.index =
          i;


        this.dots.appendChild(
          button
        );

      }

    }


    /* =======================================================
       EVENTS
       ======================================================= */

    bindEvents() {

      var self = this;


      if (this.prev) {

        this.prev.addEventListener(
          'click',
          function () {

            self.goTo(
              self.current - 1
            );

          }
        );

      }


      if (this.next) {

        this.next.addEventListener(
          'click',
          function () {

            self.goTo(
              self.current + 1
            );

          }
        );

      }


      if (this.dots) {

        this.dots.addEventListener(
          'click',
          function (event) {

            var dot =
              event.target.closest(
                '.mf-carousel-dot'
              );


            if (!dot) {

              return;

            }


            self.goTo(
              Number(
                dot.dataset.index
              )
            );

          }
        );

      }


      window.addEventListener(
        'resize',
        function () {

          self.updateVisible();

        }
      );


      /* TOUCH SWIPE */

      var startX = 0;

      var endX = 0;


      this.track.addEventListener(
        'touchstart',
        function (event) {

          startX =
            event.changedTouches[0]
              .screenX;

        },
        {
          passive: true
        }
      );


      this.track.addEventListener(
        'touchend',
        function (event) {

          endX =
            event.changedTouches[0]
              .screenX;


          var distance =
            startX - endX;


          if (
            Math.abs(distance) < 50
          ) {

            return;

          }


          if (
            distance > 0
          ) {

            self.goTo(
              self.current + 1
            );

          } else {

            self.goTo(
              self.current - 1
            );

          }

        },
        {
          passive: true
        }
      );

    }


    /* =======================================================
       GO TO
       ======================================================= */

    goTo(index) {

      if (
        this.total <= 1
      ) {

        return;

      }


      this.current =
        Math.max(
          0,
          Math.min(
            index,
            this.total - 1
          )
        );


      this.update();

    }


    /* =======================================================
       UPDATE
       ======================================================= */

    update() {

      var firstSlide =
        this.slides[0];


      if (!firstSlide) {

        return;

      }


      var slideWidth =
        firstSlide
          .getBoundingClientRect()
          .width;


      var gap =
        this.visible === 1
          ? 0
          : 20;


      var offset =
        this.current *
        (
          slideWidth +
          gap
        );


      this.track.style.transform =
        'translate3d(-' +
        offset +
        'px, 0, 0)';


      /* PREVIOUS */

      if (this.prev) {

        this.prev.classList.toggle(
          'is-disabled',
          this.current === 0
        );

      }


      /* NEXT */

      if (this.next) {

        this.next.classList.toggle(
          'is-disabled',
          this.current >=
          this.total - 1
        );

      }


      /* DOTS */

      if (this.dots) {

        var dots =
          this.dots.querySelectorAll(
            '.mf-carousel-dot'
          );


        dots.forEach(
          function (dot, index) {

            dot.classList.toggle(
              'is-active',
              index === this.current
            );

          }.bind(this)
        );

      }

    }

  }


  /* =========================================================
     INITIALIZE CAROUSELS
     ========================================================= */

  function initMFCarousels(scope) {

    var roots;

    if (scope && scope.classList && scope.classList.contains('mf-browse-products')) {
      roots = [scope];
    } else if (scope) {
      roots = Array.prototype.slice.call(scope.querySelectorAll('.mf-browse-products'));
    } else {
      roots = Array.prototype.slice.call(document.querySelectorAll('.mf-browse-products'));
    }


    roots.forEach(
      function (root) {

        if (
          root.dataset.mfCarouselReady ===
          'true'
        ) {

          return;

        }


        var track =
          root.querySelector(
            '.mf-carousel-track'
          );


        if (!track) {

          return;

        }


        root.dataset.mfCarouselReady =
          'true';


        new MFProductCarousel(
          root
        );

      }
    );

  }


  /* =========================================================
     LOAD RECOMMENDATIONS
     ========================================================= */

  function loadMFRecommendations(root) {

    if (!root) {

      return;

    }


    /*
      If Shopify has already rendered
      recommendations, initialize them
      immediately.
    */

    var existingTrack =
      root.querySelector(
        '.mf-carousel-track'
      );


    if (
      existingTrack &&
      root.querySelector(
        '.mf-product-slide'
      )
    ) {

      var existingContainer =
        root.querySelector(
          '[data-mf-recommendations]'
        );


      if (existingContainer) {

        existingContainer.classList.add(
          'is-loaded'
        );

      }


      initMFCarousels(root);

      return;

    }


    /*
      Prevent duplicate API calls.
    */

    if (
      root.dataset.mfRecommendationsLoaded ===
      'true'
    ) {

      return;

    }


    var productId =
      root.dataset.productId;


    var sectionId =
      root.dataset.sectionId;


    var limit =
      root.dataset.limit || '10';


    /*
      Product ID is required.
    */

    if (!productId) {

      console.warn(
        'Melbourne Furniture: Product ID not found. Recommendations require a product page.'
      );


      showEmptyState(root);

      return;

    }


    root.dataset.mfRecommendationsLoaded =
      'true';


    var container =
      root.querySelector(
        '[data-mf-recommendations]'
      );


    if (!container) {

      return;

    }


    /*
      Shopify recommendations endpoint.
    */

    var shopifyRoot =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';


    var url =
      shopifyRoot +
      'recommendations/products' +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      encodeURIComponent(limit);


    fetch(
      url,
      {
        method: 'GET',

        headers: {
          'X-Requested-With':
            'XMLHttpRequest',

          'Accept':
            'text/html'
        }
      }
    )

    .then(
      function (response) {

        if (!response.ok) {

          throw new Error(
            'Recommendation request failed: ' +
            response.status
          );

        }


        return response.text();

      }
    )

    .then(
      function (html) {

        var parser =
          new DOMParser();


        var parsedDocument =
          parser.parseFromString(
            html,
            'text/html'
          );


        var returnedContainer =
          parsedDocument.querySelector(
            '[data-mf-recommendations]'
          );


        /*
          Shopify may return the entire
          section depending on theme setup.
        */

        if (!returnedContainer) {

          /*
            Try finding the product
            carousel directly.
          */

          var returnedCarousel =
            parsedDocument.querySelector(
              '.mf-carousel-wrapper'
            );


          if (returnedCarousel) {

            container.innerHTML =
              returnedCarousel.outerHTML;


            var returnedDots =
              parsedDocument.querySelector(
                '.mf-carousel-dots'
              );


            if (returnedDots) {

              container.insertAdjacentHTML(
                'beforeend',
                returnedDots.outerHTML
              );

            }


            var returnedViewAll =
              parsedDocument.querySelector(
                '.mf-view-all-wrapper'
              );


            if (returnedViewAll) {

              container.insertAdjacentHTML(
                'beforeend',
                returnedViewAll.outerHTML
              );

            }


            container.classList.add(
              'is-loaded'
            );


            initMFCarousels(root);

            return;

          }


          showEmptyState(root);

          return;

        }


        /*
          Copy only the recommendation
          contents.
        */

        container.innerHTML =
          returnedContainer.innerHTML;


        container.classList.add(
          'is-loaded'
        );


        /*
          Initialize carousel after
          products are inserted.
        */

        initMFCarousels(root);

      }
    )

    .catch(
      function (error) {

        console.error(
          'Melbourne Furniture recommendations error:',
          error
        );


        /*
          Do not immediately display
          "No recommended products"
          during a temporary request
          failure.

          Try Shopify's section rendering
          endpoint as a fallback.
        */

        loadSectionFallback(
          root
        );

      }
    );

  }


  /* =========================================================
     SECTION RENDERING FALLBACK
     ========================================================= */

  function loadSectionFallback(root) {

    var container =
      root.querySelector(
        '[data-mf-recommendations]'
      );


    var productId =
      root.dataset.productId;


    var sectionId =
      root.dataset.sectionId;


    var limit =
      root.dataset.limit || '10';


    if (
      !container ||
      !productId ||
      !sectionId
    ) {

      showEmptyState(root);

      return;

    }


    var shopifyRoot =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';


    var fallbackUrl =
      shopifyRoot +
      'recommendations/products' +
      '?product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      encodeURIComponent(limit) +
      '&section_id=' +
      encodeURIComponent(sectionId);


    fetch(
      fallbackUrl,
      {
        method: 'GET',
        headers: {
          'Accept': 'text/html'
        }
      }
    )

    .then(
      function (response) {

        if (!response.ok) {

          throw new Error(
            'Fallback request failed'
          );

        }


        return response.text();

      }
    )

    .then(
      function (html) {

        var parser =
          new DOMParser();


        var documentHTML =
          parser.parseFromString(
            html,
            'text/html'
          );


        var returnedContainer =
          documentHTML.querySelector(
            '[data-mf-recommendations]'
          );


        if (!returnedContainer) {

          showEmptyState(root);

          return;

        }


        container.innerHTML =
          returnedContainer.innerHTML;


        container.classList.add(
          'is-loaded'
        );


        initMFCarousels(root);

      }
    )

    .catch(
      function (error) {

        console.error(
          'Melbourne Furniture fallback recommendations error:',
          error
        );


        showEmptyState(root);

      }
    );

  }


  /* =========================================================
     EMPTY STATE
     ========================================================= */

  function showEmptyState(root) {

    var container =
      root.querySelector(
        '[data-mf-recommendations]'
      );


    if (!container) {

      return;

    }


    container.classList.add(
      'is-loaded'
    );


    container.innerHTML =
      '<div class="mf-empty">' +
        '<p>No recommended products available.</p>' +
      '</div>';

  }


  /* =========================================================
     INITIALIZE
     ========================================================= */

  function initMFProductRecommendations() {

    document
      .querySelectorAll(
        '.mf-browse-products'
      )
      .forEach(
        function (root) {

          loadMFRecommendations(
            root
          );

        }
      );

  }


  /* =========================================================
     DOM READY
     ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initMFProductRecommendations
    );

  } else {

    initMFProductRecommendations();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var root =
        event.target.querySelector(
          '.mf-browse-products'
        );


      if (root) {

        loadMFRecommendations(
          root
        );

      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();
})();
